export default "/images/vendor/@coreui/icons/svg/flag/cif-et.svg?b6418d2dfa95c7da4e5cdfaa176aa09f";